export enum GameTypeEnum {
  LiveCasino = "LC",
  Slot = "SL",
  ESport = "ES",
  Sport = "SB",
}

export enum SubGameEnum {
  Featured = 1,
  NotFeatured = 0,
  NewGame = 1,
  OldGame = 0,
  Lobby = 1,
  NotLobby = 0,
}
